import { Badge } from '@/components/ui/badge';

const STATUS_VARIANTS: Record<string, 'default' | 'secondary' | 'destructive' | 'outline'> = {
  draft: 'secondary',
  active: 'default',
  closed: 'outline',
};

const STATUS_LABELS: Record<string, string> = {
  draft: 'Draft',
  active: 'Active',
  closed: 'Closed',
};

interface PollStatusBadgeProps {
  status: string;
}

export function PollStatusBadge({ status }: PollStatusBadgeProps) {
  return (
    <Badge variant={STATUS_VARIANTS[status] || 'secondary'}>
      {STATUS_LABELS[status] || status}
    </Badge>
  );
}
